// Style PDP MW Product Bundles  app 
if ($('.mw-product-addons').length == 0) {
    setTimeout(function () {
        document.querySelector("mw-product-addons").shadowRoot.append(
            Object.assign(document.createElement("STYLE"), {
                innerText: `div.ProductAddons {
                    background: #fff;
                    border-bottom-right-radius: 45px;
                    margin-top: 30px;
                    padding: 17px 18px 20px 14px;
                    display: flex;
                    flex-wrap: wrap;
                    margin-bottom: 16px;
                }

                .ProductAddons__ErrorWarpper {
                    order: 0;
                    width: 100%;
                    margin: 0 0 20px 0;
                    font-family: "SofiaProSoftMedium", sans-serif;
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 1.63;
                }

                .ProductAddons__Content {
                    margin-top: 0;
                    order: 2;
                    width: 100%;
                }

                .ProductAddons__Heading {
                    order: 1;
                    width: 100%;
                }
                @media screen and (max-width: 767px) {
                    div.ProductAddons {
                        padding: 13px 18px 20px 14px;
                        margin-top: 20px;
                    }
                }
                div.ProductAddons .ProductAddons__Qty {
                    display: none;
                }
                div.ProductAddons .ProductAddons__Heading {
                    font-family: "SofiaProSemiBold", sans-serif;
                    font-size: 16px;
                    font-weight: 600;
                    line-height: 1.63;
                    letter-spacing: normal;
                    color: #3a3a3a;
                    margin: 0 0 22px 0;
                }
                @media screen and (max-width: 767px) {
                    div.ProductAddons .ProductAddons__Heading {
                        margin: 0 0 24px 0;
                    }
                }
                div.ProductAddons .ProductAddons__Item:not(:last-child) {
                    border: none !important;
                }
                @media screen and (min-width: 768px) and (max-width: 1023px) {
                    div.ProductAddons .ProductAddons__Item:not(:first-child) {
                        padding-top: 0;
                    }
                }
                div.ProductAddons .ItemCheckbox input[type="checkbox"] {
                    position: relative;
                    border: 2px solid #686868;
                    border-radius: 4px;
                    background: none;
                    cursor: pointer;
                    line-height: 0;
                    margin: 0 0.6em 0 0;
                    outline: 0;
                    padding: 0 !important;
                    vertical-align: text-top;
                    height: 22px;
                    width: 22px;
                    -webkit-appearance: none;
                }
                @media screen and (min-width: 768px) and (max-width: 1023px) {
                    div.ProductAddons .ItemCheckbox input[type="checkbox"] {
                        width: 15px;
                        height: 15px;
                    }
                }
                div.ProductAddons .ItemCheckbox input[type="checkbox"]:hover {
                    opacity: 1;
                }
                div.ProductAddons .ItemCheckbox input[type="checkbox"]:checked {
                    background-color: black;
                    border-color: black;
                    opacity: 1;
                }
                div.ProductAddons .ItemCheckbox input[type="checkbox"]:before {
                    content: "";
                    position: absolute;
                    right: 50%;
                    top: 50%;
                    width: 6px;
                    height: 12px;
                    border: solid #fff;
                    border-width: 0 2px 2px 0;
                    margin: -1px -1px 0 -1px;
                    transform: rotate(45deg) translate(-50%, -50%);
                    z-index: 2;
                }
                @media screen and (min-width: 768px) and (max-width: 1023px) {
                    div.ProductAddons .ItemCheckbox input[type="checkbox"]:before {
                        width: 6px;
                        height: 10px;
                    }
                }
                div.ProductAddons .ProductAddons__Content .ProductAddons__Item {
                    align-items: normal;
                }
                div.ProductAddons .ProductAddons__Content .ProductAddons__Item .ProductAddons__Pricing {
                    flex: 0 0 60px;
                }
                @media screen and (min-width: 768px) and (max-width: 1023px) {
                    div.ProductAddons .ProductAddons__Content .ProductAddons__Item .ProductAddons__Pricing .ProductAddons__Price {
                        padding-right: 8px;
                        font-size: 14px;
                    }
                }
                div.ProductAddons .ProductAddons__Content .ProductAddons__ContentBlock {
                    flex: 0 1 80%;
                    max-width: 80%;
                }
                @media screen and (min-width: 768px) and (max-width: 1023px) {
                    div.ProductAddons .ProductAddons__Content .ProductAddons__ContentBlock {
                        flex: 0 1 50%;
                        max-width: 50%;
                    }
                }
                div.ProductAddons .ProductAddons__Content .ProductAddons__ContentBlock .ProductAddons__Title {
                    font-family: "SofiaProSoftMedium";
                    font-size: 15px;
                    font-weight: 500;
                    line-height: 1.33;
                    letter-spacing: normal;
                    color: #3a3a3a;
                    margin: 0;
                }

                div.ProductAddons .ProductAddons__Content .ProductAddons__ContentBlock .ProductAddons__Title a {
                    word-wrap: unset;
                    word-break: normal;
                }
                @media screen and (min-width: 768px) and (max-width: 1023px) {
                    div.ProductAddons .ProductAddons__Content .ProductAddons__ContentBlock .ProductAddons__Title {
                        margin: 0;
                        font-size: 14px;
                    }
                }
                div.ProductAddons .ProductAddons__Content .ProductAddons__ContentBlock .BundleProductSelect__Control {
                    font-family: "SofiaProSoftLight";
                    font-size: 16px;
                    font-weight: 300;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #686868;
                    padding: 0 10px;
                }
                div.ProductAddons .ProductAddons__Content .ProductAddons__ContentBlock .BundleProductSelect {
                    max-width: 147px;
                    padding-right: 10px;
                    height: 30px;
                    position: relative;
                }
                div.ProductAddons .ProductAddons__Content .ProductAddons__ContentBlock .BundleProductSelect:before {
                    background: url("icon-chevron-down.svg") no-repeat;
                    border: none;
                    width: 16px;
                    height: 16px;
                    position: absolute;
                    right: 5px;
                    top: 5px;
                }
                div.ProductAddons .ProductAddons__Content .ProductAddons__VariantsWrapper .ProductAddons__VariantTitle {
                    font-family: "SofiaProSoftLight";
                    font-size: 15px;
                    font-weight: 300;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: 1.73;
                    letter-spacing: normal;
                }
                div.ProductAddons .ProductAddons__Content .ProductAddons__PriceWrap .ProductAddons__Price {
                    font-family: "SofiaProSoftRegular";
                    font-size: 15px;
                    font-weight: normal;
                    line-height: 1.73;
                    letter-spacing: normal;
                    text-align: right;
                    color: black;
                }
                div.ProductAddons .ProductAddons__Content .ProductAddons__ImageBlock {
                    margin-right: 12px;
                    flex: 0 0 81px;
                }
                @media screen and (min-width: 768px) and (max-width: 1023px) {
                    div.ProductAddons .ProductAddons__Content .ProductAddons__ImageBlock {
                        margin-right: 7px;
                        flex: 0 0 40px;
                    }
                }
                div.ProductAddons .ProductAddons__Content .ProductAddons__ImageBlock .ProductAddons__Image {
                    background-color: white;
                    border-color: #f0efed;
                    border-width: 1px;
                    height: 80px;
                    max-width: 100%;
                    min-width: 80px;
                    position: relative;
                    width: 80px;
                }
                @media screen and (min-width: 768px) and (max-width: 1023px) {
                    div.ProductAddons .ProductAddons__Content .ProductAddons__ImageBlock .ProductAddons__Image {
                        height: 40px;
                        width: 40px;
                        min-width: 40px;
                    }
                }
                `
            })
        )
    }, 2000)
}

// Window resize reload page
$(window).resize(function () {
    // location.reload();
});
// Handle js on PDP upgrade
$('.pdp-upgrade-v2 .header_description .not-showmore').on("click", function () {

    if ($(window).width() > 1024) {
        $('html, body').animate({
            scrollTop: $(".product-description").offset().top - 300
        }, 1000);
    } else {
        $('html, body').animate({
            scrollTop: $(".product-description").offset().top - 80
        }, 1000);
    }

    $('.product-description .show-more').trigger("click");

})

setTimeout(function () {
    $(".oct-calculator-open").on("click", function () {
        $(this).parents('.oct-calculator-container').toggleClass("active")
    })
}, 2000)

// Product ichange
setTimeout(function () {
    $('.iChangeApp--widget').appendTo('.block-ichange')
}, 2000)

// Popup feature
$('.block_feature_popup').appendTo('.feature_popup_content');

// PDP upgrade
$(".main-pdp-tab .item-tab h3").on("click", function () {
    if ($(this).parent(".main-pdp-tab .item-tab").hasClass("active")) {
        $(this).parent('.item-tab').removeClass("active");
    } else {
        $(".main-pdp-tab .item-tab").removeClass("active");
        $(this).parent('.item-tab').addClass("active");
    }

    $('.product-description').removeClass("active")
});


$(".pdp-upgrade-v2 .product-description h3").on("click", function () {
    $(this).parent(".product-description").toggleClass("active");
    $(".main-pdp-tab .item-tab").removeClass("active");
});

// Handle gallery image
$(".pdp_gallery_more").on("click", function () {
    $(this).parents(".slider-mobile-gutter").addClass("active");
})


// Popup list feature
$(".content_header").on("click", function () {
    $(this).parents(".item-list-product").addClass("active");
    $(this).parents("body").addClass("has-popup");
})

$(".btn-close").on("click", function (e) {
    $(this).parents(".item-list-product").removeClass("active");
    $(this).parents("body").removeClass("has-popup");
});

$(document).mouseup(function (e) {
    if ($(e.target).is(".list-modal-content") === false) {
        $(".item-list-product").removeClass("active");
        $("body").removeClass("has-popup");
    }
});

// Mobile scrollbar image gallery
$(document).ready(function () {
    $('.scrollbar-inner').scrollbar();
});

// Fix choose size variant
$(document).ready(function () {
    $('.has_variant_size ul li.disabled').on('click', function () {
        $('.product-form__buttons.has_size .js-ajax-add-to-cart').prop('disabled', true);
        $('.product-form__buttons.has_size .js-ajax-add-to-cart span').text("Sold out");
        $('.size_select li').removeClass('choose_size');
    })

    $('.has_variant_size ul li:not(.disabled)').on('click', function () {
        $('.product-form__buttons.has_size .js-ajax-add-to-cart').prop('disabled', false);
        $('.product-form__buttons.has_size .js-ajax-add-to-cart span').text("Add to Cart");
    })

    let active_size = $('.has_variant_size .active_size').text();
    $('.has_variant_size span.value').text(active_size);

    $('.has_variant_size ul li').on('click', function () {
        let valueSize = $(this).text();
        $('.has_variant_size span.value').text(valueSize);
    })
})

// Video show 4th
const hasVideoDiv = document.querySelector('slider-component .product_has_video');

const container = document.querySelector('slider-component .product__media-list');

if (hasVideoDiv && container) {
    const fourthElement = container.children[3];
    hasVideoDiv.classList.add("landscape_desktop");
    container.insertBefore(hasVideoDiv, fourthElement);
}

// Check video portait or lanspace
$(document).ready(function () {

    document.querySelectorAll('.slider_pdp_v2 .product_has_video .deferred-media.media').forEach((media) => {
        const video = media.querySelector('video');
        if (video) {
            const width = video.videoWidth;
            const height = video.videoHeight;

            if (width > height) {
                // console.log(`${video.id} is Landscape`);
                $(video).parents('.product_has_video').addClass('landscape');
            } else if (width < height) {
                $(video).parents('.slider_pdp_v2 .product_has_video').remove();
            } else {
                $(video).parents('.product_has_video').addClass('square');
                $(video).parents('.slider_pdp_v2 .product_has_video').remove();

            }
        }
    });

    // Product modal video
    $('.product_has_video video').each(function () {
        const video = this;

        $(video).on('loadedmetadata', function () {
            const width = video.videoWidth;
            const height = video.videoHeight;

            if (width > height) {
                // console.log(`${video.id} is Landscape`);
                $(video).parents('.product_has_video').addClass('landscape');
            } else if (width < height) {
                $(video).parents('.product_has_video').addClass('portrait');

            } else {
                $(video).parents('.product_has_video').addClass('square');
            }
        });
    });

    // PDP upgrade v2
    const $pdpGallerySlider = $('.slider_pdp_v2 .product__media-list_slider');

    $pdpGallerySlider.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
    });

    function playPdpSliderVideo(slick, slideIndex) {
        if (!slick || !slick.$slides || !slick.$slides[slideIndex]) return;

        const deferredMedia = slick.$slides[slideIndex].querySelector('deferred-media');

        if (deferredMedia && window.playDeferredMedia) {
            window.playDeferredMedia(deferredMedia);
        }
    }

    $pdpGallerySlider.on('init afterChange', function (event, slick, currentSlide) {
        const slideIndex = typeof currentSlide === 'number' ? currentSlide : slick.currentSlide;
        playPdpSliderVideo(slick, slideIndex);
        if (window.playPdpGalleryVideos) {
            window.playPdpGalleryVideos();
        }
    });


    // Hidden video portrait in PDP
    document.querySelectorAll('.product-media-modal__content .deferred-media.media.product_has_video').forEach((media) => {
        const img = media.querySelector('.image_video_deferred');
        if (img) {
            img.onload = () => {
                if (media.naturalHeight > img.naturalWidth) {
                } else {
                    media.classList.add('video_autoplay');
                }
            };

            if (img.complete) {
                if (img.naturalHeight > img.naturalWidth) {
                    media.classList.add('hidden_modal_desktop');
                } else {
                    media.classList.add('video_autoplay');
                }
            }
        }
    });


});


// Check size video image landspace
document.querySelectorAll('.thumbnail-list .has_video').forEach((container) => {
    const img = container.querySelector('img');
    if (img) {
        img.onload = () => {
            if (img.naturalWidth > img.naturalHeight) {
                container.classList.add('hidden_thumbnail_lanspace');
            }
        };

        if (img.complete) {
            if (img.naturalWidth > img.naturalHeight) {
                container.classList.add('hidden_thumbnail_lanspace');
            }
        }
    }
});

// Video auto play when close modal product gallery
const videos = document.querySelectorAll('video');

document.addEventListener('click', () => {
    videos.forEach(video => {
        if (video.closest('.has_video_item')) {
            return;
        }

        if (video.paused) {
            video.play();
        }
    });
});

document.addEventListener('touchstart', () => {
    videos.forEach(video => {
        if (video.closest('.has_video_item')) {
            return;
        }

        if (video.paused) {
            video.play();
        }
    });
});

// Total price placement handled in mws-bundle-helper.liquid


$(document).ready(function () {
    if (window.playPdpGalleryVideos) {
        window.playPdpGalleryVideos();
    }
});